import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms'
import { Router, ActivatedRoute } from '@angular/router';
// import { StaffService } from "../Shared/staff.service";
import { UsermanagementService } from "../Shared/usermanagement.service";
import { CommonmastersService } from "../../commonmasters/commonmasters.service";

import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";

@Component({
  selector: 'app-staffmaster',
  templateUrl: './staffmaster.component.html',
  styleUrls: ['./staffmaster.component.css']
})

export class StaffmasterComponent implements OnInit {

  staffMasterForm: FormGroup;
  AddButtonText: string;
  DesignationList: any[] = [];
  EmployeeList: any[] = [];
  RoleList: any[] = [];
  Checked: boolean = false;
  readonlyTextBox: boolean = true;
  toast: Toastpayload;
  regex: any = "^[A-Za-z]*";

  constructor(private router: Router,
    private route: ActivatedRoute,
    // public staffService: StaffService,
    private usermanagementService: UsermanagementService,
    private toasterserviceService: ToasterserviceService,
    private commonmastersService: CommonmastersService,
    private formBuilder: FormBuilder) { }

  ngOnInit() {

    this.StaffList();
    this.Designation();
    this.Roles();
    this.ResetControls();
    this.AddButtonText = "Save";
  }

  ResetControls() {
    // this.staffMasterForm = new FormGroup({
    //   Code: new FormControl('', Validators.required),
    //   EmployeeId: new FormControl(0, Validators.required),
    //   UserName: new FormControl('', Validators.required),
    //   Password: new FormControl('', Validators.required),
    //   ConfirmPassword: new FormControl('', Validators.required),
    //   RoleId: new FormControl(0, Validators.required),
    //   IsTermaination: new FormControl(false),
    //   TerminationDate: new FormControl({ value: '', readonly: this.readonlyTextBox }),
    // });

    this.staffMasterForm = this.formBuilder.group({
      Id: [0],
      Code: ['', [Validators.required]],
      EmployeeId: [0, [Validators.required]],
      UserName: ['', [Validators.required,
      Validators.minLength(6),
      Validators.maxLength(20),
      Validators.pattern(this.regex)]],
      Password: ['', [Validators.required]],
      ConfirmPassword: ['', [Validators.required]],
      RoleId: [0, [Validators.required]],
      DesignationId: [0, [Validators.required]],
      IsTermaination: [false, [Validators.required]],
      TerminationDate: ['', { readonly: this.readonlyTextBox }],
      IsActive: [1, [Validators.required]],
      Flag: [1, [Validators.required]],
    })



    //     this.info=this.fb.group({
    //       firstName:['',[Validators.required,
    //         Validators.minLength(3),
    //         Validators.maxLength(10),
    //         Validators.pattern(this.regex)]],
    //       lastName:['',[Validators.required,
    //         Validators.minLength(3),
    //         Validators.maxLength(10),
    //         Validators.pattern(this.regex)]],
    //       gender:['',Validators.required],
    //       state:['',Validators.required],
    //       qualification:['',Validators.required]
    // })
  }

  StaffList() {
    this.commonmastersService.FetchStaffList().subscribe(data => {
      this.EmployeeList = data;

    })
  }

  Designation() {
    this.commonmastersService.GetDesignationList().subscribe(data => {
      this.DesignationList = data;

    })
  }

  Roles() {
    this.commonmastersService.GetRoleList().subscribe(data => {
      this.RoleList = data;

    })
  }

  checkTermination(checked) {
    if (!checked) {
      this.readonlyTextBox = true;
    } else {
      this.readonlyTextBox = false;
    }
  }

  onSubmit(form: FormGroup) {

    this.toast = {
      message: "No Message Now!",
      title: 'Staff Master',
      ic: {
        timeOut: 2000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    var val = this.FormValidationbyToast(form);
    if (val != 0) {
      return;
    }

    if (form.value.UserName != null) {
      // form.value.Id = form.value.EmployeeId; //?? now is Usermanagement
      if (form.value.IsTermaination == 1) {
        // console.log('Is Termaination on', form.value.IsTermaination);

      }
      else {
        form.value.TerminationDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
      }

      this.usermanagementService.IUDUser(form.value)
        .toPromise()
        .then(data => {

          // if(data.UniqueId == 2200 && data.ResponseId == 200) {
          //   this.toast.type = 'warning';     }  
          // else{ this.toast.type = 'success'; }   
          // this.toast.message = data.ResponseMessage;

          this.toast.title = 'Staff Master';
          this.toast.message = 'Staff roles successfully saved.'
          this.toast.type = 'success';
          this.toasterserviceService.showToast(this.toast);

          this.router.navigate(['/stafflist']);
        })
    }
  }

  MatchPassword(password: string, confirmPassword: string) {
    return (formGroup: FormGroup) => {
      const passwordControl = formGroup.controls[password];
      const confirmPasswordControl = formGroup.controls[confirmPassword];

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (confirmPasswordControl.errors && !confirmPasswordControl.errors.passwordMismatch) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }
    }
  }

  /// User form validation
  FormValidationbyToast(form: FormGroup): any {

    var retValue = 0;

    this.toast = {
      message: "No Message Now!",
      title: 'Staff Master',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    if (form.value.Code === '') {

      this.toast.message = 'Please enter user code'
      this.toast.type = 'error';
      this.toasterserviceService.showToast(this.toast);
      retValue = 1;
    }

    if (form.value.EmployeeId === 0) {

      this.toast.message = 'Please select the employee'
      this.toast.type = 'error';
      this.toasterserviceService.showToast(this.toast);
      retValue = 1;
    }

    if (form.value.UserName === '') {

      this.toast.message = 'Please enter user name'
      this.toast.type = 'error';
      this.toasterserviceService.showToast(this.toast);
      retValue = 1;
    }

    if (form.value.password === '') {

      this.toast.message = 'Please enter password'
      this.toast.type = 'error';
      this.toasterserviceService.showToast(this.toast);
      retValue = 1;
    }

    if (form.value.RoleId === 0) {

      this.toast.message = 'Please select Designation'
      this.toast.type = 'error';
      this.toasterserviceService.showToast(this.toast);
      retValue = 1;
    }

    if (form.value.IsTermaination == 1) {
      if (form.value.RoleId === 0) {

        this.toast.message = 'Please select Termination date'
        this.toast.type = 'error';
        this.toasterserviceService.showToast(this.toast);
        retValue = 1;
      }
    }

    return retValue;
  }

}
